import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { line } from 'd3-shape';
import Circle from './Circle.js';
import Line from './Line.js';

var DataSeries = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DataSeries, _Component);
  function DataSeries() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = DataSeries.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      xAccessor = _this$props.xAccessor,
      yAccessor = _this$props.yAccessor,
      xScale = _this$props.xScale,
      yScale = _this$props.yScale,
      data = _this$props.data,
      fill = _this$props.fill,
      strokeWidth = _this$props.strokeWidth,
      seriesName = _this$props.seriesName,
      hoverIndex = _this$props.hoverIndex;
    var interpolatePath = line().x(function (d) {
      return xScale(xAccessor(d));
    }).y(function (d) {
      return yScale(yAccessor(d));
    });
    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(Line, {
      path: interpolatePath(data),
      stroke: fill,
      strokeWidth: strokeWidth,
      id: seriesName
    }), hoverIndex && /*#__PURE__*/React.createElement(Circle, {
      cx: xScale(xAccessor(data[hoverIndex])),
      cy: yScale(yAccessor(data[hoverIndex])),
      r: 5,
      fill: fill
    }), this.props.children);
  };
  return DataSeries;
}(Component);
DataSeries.defaultProps = {
  data: [],
  fill: 'white',
  xAccessor: function xAccessor(d) {
    return d.x;
  },
  yAccessor: function yAccessor(d) {
    return d.y;
  },
  displayDataPoints: true
};
DataSeries.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.array,
  displayDataPoints: PropTypes.bool,
  fill: PropTypes.string,
  xAccessor: PropTypes.func,
  yAccessor: PropTypes.func,
  children: PropTypes.node,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  strokeWidth: PropTypes.number,
  seriesName: PropTypes.string,
  hoverIndex: PropTypes.number
} : {};

export { DataSeries as default };
